import { Directive, OnDestroy, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { Subject } from 'rxjs'
import { PackageCheckinMode } from './storage-node'

@Directive({
  selector: '[appPackageCheckinModeSelect]',
})
export class PackageCheckinModeSelectDirective implements OnDestroy {
  private select = inject(ElderSelectComponent)
  private enumTranslationService = inject(ElderEnumTranslationService)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _unsubscribe$ = new Subject<void>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = this.enumTranslationService.enumDataSource(
      PackageCheckinMode,
      'storage.packageCheckinMode',
      false
    )
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    this._unsubscribe$.next()
    this._unsubscribe$.complete()
  }
}
